// src/components/Navbar.js
import React, { useContext } from "react";
import Logo from "../Assets/Logo.svg";
import { Link } from 'react-router-dom';
import { BsCart2, BsTwitter, BsYoutube } from "react-icons/bs";
import { HiOutlineBars3 } from "react-icons/hi2";
import { SiLinkedin } from "react-icons/si";
import { FaFacebookF } from "react-icons/fa";
import { AuthContext } from '../Context/AuthContext';

const Navbar = ({ openLoginModal, openRegisterModal, setOpenMenu }) => {
    const { currentUser, logout } = useContext(AuthContext);

    return (
        <nav>
            <div className="nav-left-container">
                <div className="nav-logo-container">
                    <img src={Logo} alt="Logo" />
                </div>
                <div className="nav-icons-container">
                    <BsTwitter />
                    <SiLinkedin />
                    <BsYoutube />
                    <FaFacebookF />
                </div>
            </div>
            
            <div className="navbar-links-container">
                <Link to="/">Home</Link>
                <Link to="/recipes">Gerechten</Link>
                <Link to="/over">Over</Link>
                <Link to="/contact">Contact</Link>
                {!currentUser ? (
                    <button onClick={openLoginModal} className="inlog-butten">
                        Inloggen
                    </button>
                ) : (
                    <>
                        {currentUser.role === 'eindgebruiker' && (
                            <Link to="/Eindgebruiker">
                            Eindgebruiker
                            </Link>
                        )}
                           {currentUser.role === 'contentbeheerder' && (
                            <Link to="/ContentManager">
                            Contentbeheerder
                            </Link>
                        )}
                            {currentUser.role === 'ah-medewerker' && (
                            <Link to="/EmployeeManager">
                            Ah-medewerker
                            </Link>
                        )}
                            {currentUser.role === 'chef kok' && (
                            <Link to="/ChefManager">
                            Chef kok
                            </Link>
                        )}
                        <button onClick={logout} className="inlog-butten">
                            Uitloggen
                        </button>
                    </>
                )}
            </div>
            <div className="navbar-menu-container">
                <HiOutlineBars3 onClick={() => setOpenMenu(true)} />
            </div>
        </nav>
    );
};

export default Navbar;
